import Page from './[...page]'
import type { GetStaticProps } from 'next'
import { getBuilderStaticProps } from '../util/builder-functions'

export const getStaticProps: GetStaticProps = async (context) => {
  return getBuilderStaticProps('page', context)
}

export default Page
